interface Props {
    children: React.ReactNode;
}

export const VerificationDetailsSectionTitle = ({ children }: Props): React.ReactElement => {
    return (
        <header className="font-weight-bold mb-2">{children}</header>
    )
}